import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray, AbstractControl, ValidationErrors } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { LOCAL_VAR } from '@app/core/constants';
import { AgentsService } from '@app/core/service/agents.service';
import { DealsService } from '@app/core/service/deals.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-srp-min-max-form',
  templateUrl: './srp-min-max-form.component.html',
  styleUrls: ['./srp-min-max-form.component.scss']
})
export class SrpMinMaxFormComponent implements OnInit {
SRPCreateFrom: FormGroup;

  @Input()
    dealId? = '';

  @Input()
    product? = '';

  @Output()
    onSubmitStepChange? = new EventEmitter<any>();
    
  dealData: any;
  SRPData: any;
  isLoading: boolean;
  user: Authentication.User;
  flNotSelected:boolean=false;

  months = Array.from({ length: 12 }, (_, i) => `Month ${i + 1}`);
  services = Array.from({ length: 10 }, (_, i) => `Month ${i + 1}`);
  agentName='';
  proInfo='';
  agent: any = null;
  products: any = null;
  minMaxProducts: FormArray;
  currencyOptions = {
    prefix: '$ ',
    thousands: ',',
    decimal: '.',
    precision: 0,
    allowNegative: false
  };
  
  constructor(public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
    public authenticationService: AuthenticationService,
    private dealsService: DealsService,
    private agentsService: AgentsService) { 
      this.user = this.authenticationService.credentials.user;
      this.dealData = this.dealsService.dealData;
      this.agent = localStorage.getItem(LOCAL_VAR.selectedAgent);
      this.agent = JSON.parse(this.agent);
}

  ngOnInit() {
    if(this.dealData.SRPForm && this.dealData.SRPForm[this.product]){
      this.SRPData=this.dealData.SRPForm[this.product];
    }   
    if(this.dealData.state!='FL') this.flNotSelected=true;
    this.createForm();    
    if(this.dealData.agencyId){
      this.getAgencyList();
    }
    this.getSelectedProducts();
  }

  getAgencyList() {
    this.isLoading = true;
    this.agentsService
      .getAgencyList()
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe((response: any) => {
        response.records.forEach((agency: any) => {
          if (this.dealData.agencyId === agency._id) {
            this.agentName = agency.agencyname;
          }
        });
      });
    // console.log('333333');
  }

   getSelectedProducts() {
    this.dealsService
      .getDealSelectedProducts(this.agent._id, this.dealId)
      .pipe(
        finalize(() => {
          // this.isProductLoading = false;
        })
      )
      .subscribe((response: any) => {
        if (response) {
          // this.products= response;
          let currentProduct='DOWC';

          const data: any = [];
          const incentive = this.dealData.SRPForm && this.dealData.SRPForm.productMinMax? this.dealData.SRPForm.productMinMax:[];
         
          $.each(response, function(index, value) {
            let status = true;
            $.each(incentive, function(index, val) {
              if (currentProduct ==value.category && val.category == value.category && val.slug == value.slug) {
                status = false;
                data.push(val);
                return false;
              }
            });
            if (status) {
              data.push(value);
            }
          });
          this.products = data.filter((item: any) => {
                        return item.category == currentProduct;
                      });
          this.formControlsValueChanges();
        }
      });
  }

  private createForm() {   
    this.SRPCreateFrom = this.formBuilder.group({      
      type: [this.dealData.SRPForm?this.dealData.SRPForm.type:'', [Validators.required]],
      mode: [this.dealData.SRPForm?this.dealData.SRPForm.mode:'', [Validators.required]],
      productMinMax: this.formBuilder.array([]),
    });
    if(this.dealData.SRPForm && this.dealData.SRPForm.type){
      this.updateCurrencyPrefix(this.dealData.SRPForm.type);
    }
    if(this.dealData.SRPForm && this.dealData.SRPForm.mode){
      this.updateMinMaxValidators();
    }
     this.SRPCreateFrom.get('type').valueChanges.subscribe((typeValue) => {
      this.updateCurrencyPrefix(typeValue);
    });
     this.SRPCreateFrom.get('mode').valueChanges.subscribe((typeValue) => {
      this.updateMinMaxValidators();
    });
  }

  formControlsValueChanges(){
     this.minMaxProducts = this.SRPCreateFrom.get('productMinMax') as FormArray;
     this.products.forEach((product: any) => {
        this.minMaxProducts.push(this.createProductForm(product));  
     })

  }

  get productMinMaxControls() {
    return (this.SRPCreateFrom.get('productMinMax') as FormArray).controls;
  }

  updateCurrencyPrefix(type: string): void {
    const prefix = type === 'percentage' ? '% ' : '$ ';
    this.currencyOptions = {
      ...this.currencyOptions,
      prefix
    };
  }

  updateMinMaxValidators(): void {
    const productMinMaxArray = this.SRPCreateFrom.get('productMinMax') as FormArray;
    productMinMaxArray.controls.forEach(control => {
      control.setValidators(this.minMaxValidator());
      control.updateValueAndValidity();
    });
  }

  changeValidator(){

  }

  createProductForm(product: any) {
    let productname = product.name;
    if (
      product.slug.indexOf('other') > -1 &&
      product.value
    ) {
      productname =
        productname +
        ' : ' +
        product.value;
    }
    const group= this.formBuilder.group({
      name: productname,
      slug: product.slug,
      category: [product && product.category ? product.category : 'DOWC'],
      srp: [product && product.srp ? product.srp : 0],
      enableMinMax: [product && product.enableMinMax && this.flNotSelected ? true : false],      
      min: [product && product.min && this.flNotSelected ? product.min : null],
      max: [product && product.max && this.flNotSelected ? product.max : null]
    });
    group.setValidators(this.minMaxValidator());
    return group;
  }
  
  minMaxValidator() {
    let mode=this.SRPCreateFrom.get('mode').value
    return (group: AbstractControl): ValidationErrors | null => {
      const srp = group.get('srp').value?group.get('srp').value:0;
      const min = group.get('min').value?group.get('min').value:0;
      const max = group.get('max').value?group.get('max').value:0;
      const enableMinMax = group.get('enableMinMax').value?true:false;

     if (enableMinMax) {
      // Mode-specific validation
      if (mode === 'aboveCost') {
        if ((min <= srp) || (max <= srp)) {
          return { aboveCostInvalid: true };
        }
      }

      if (mode === 'aboveZero') {
        if ((min <= 0) || (max <= 0)) {
          return { aboveZeroInvalid: true };
        }
      }

      // Generic min-max validation
      if (max < min) {
        return { minMaxInvalid: true };
      }
    }

      return null;
    };
  }

  createRepairForm() {
    this.isLoading = true;
    let payload = { dealId: this.dealId, SRPForm: this.SRPCreateFrom.value }
    this.dealsService
      .stepSubmit(this.user._id, 'SRPForm', payload)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe((response: any) => {
        this.isLoading = true;
        //console.log(response, 'response step 8');
        if (response && response.filename) {
          this.SRPCreateFrom.markAsPristine();
          this.SRPCreateFrom.reset();
          this.isLoading = false;
          this.activeModal.close(response);
          // this.dealsService.getDealById(
          //   this.user._id,
          //   this.dealId
          // );
          // this.dealsService.dealData$.subscribe((dealDatas:any) => {
          //   this.isLoading = false;
          //   this.activeModal.close(dealDatas);
          // })
        } else {
          this.toastrService.warning('something went Wrong');
        }
      });
  }
  checkValidfields() {
    if (this.SRPCreateFrom.invalid || this.isLoading) {
      this.toastrService.warning('Please fill all required fields.');
      for (const i in this.SRPCreateFrom.controls) {
        this.SRPCreateFrom.controls[i].markAsTouched();
      }
    }
  }
}

